<template>
<div>
  <div v-if="loader">
    <img src="../../../../src/assets/img/loader.svg" alt="loader" class="sa-loader sa-loader-top" />
  </div>
  <div v-else>
    <review-diagnosis v-if="saveDiagDetFlag" />
    <follow-up :data="followup" v-else-if="followUpViewFlag"/>
    <template v-else>
       <div class="sa-mob-header">
      <h5 class="sa-card-tit">Add Diagnosis details</h5>
      <button class="sa-btn-back" @click="$router.push('/appointments/doctor-details/'+$route.params.appid)">
          <i class="icon-arrow-left"></i>
        </button>
  </div>
        <ValidationObserver ref="form" class="sa-mob-cont sa-mob-cont-padbt" tag="div" v-slot='{ handleSubmit }' @keyup.enter="handleSubmit(saveDiagnosisDet)" >
      <h5 class="sa-card-tit sa-mt10">General details</h5>
      <form @submit.prevent>
        <div class="sa-row">
          <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg3">
            <div class="sa-form-group">
              <label>
                Select Marital Status
              </label>
              <v-select :options="['Married','Unmarried']" class="diagno-select" id="maritalStatus" v-model="diagnosis.general_details.marital_status" name="Marital Status" ><span slot="no-options">No data</span></v-select>
            </div>
          </div>
          <div v-if="diagnosis.general_details.gender == 'Female'" class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg3">
            <div class="sa-form-group">
              <label>
                Select Pregnancy status
              </label>
              <v-select :options="['Yes','No']" class="diagno-select" id="pregnancyStatus" v-model="diagnosis.general_details.pregnency_status" name="Pregnancy Status" ><span slot="no-options">No data</span></v-select>
            </div>
          </div>
        </div>
      </form>
      <h5 class="sa-card-tit sa-mt10">Diagnosis details</h5>
      <ValidationProvider class="sa-card"  tag="div" rules="required" name="subjective" v-slot="{ errors }">
        <label class="sa-diagno-label">Subjective <span class="sa-red-text">*</span></label> 
        <textarea class="sa-textarea" placeholder="Add here" rows="1" v-model="diagnosis.diagnosis_details.subjective" id="subjective" name="Subjective" />
         <span class="sa-val-err">{{ errors[0] }}</span>
      </ValidationProvider>
      <ValidationProvider class="sa-card"  tag="div" rules="required" name="objective" v-slot="{ errors }">
        <label class="sa-diagno-label">Objective <span class="sa-red-text">*</span>
         </label>
        <textarea class="sa-textarea" placeholder="Add here" rows="1" v-model="diagnosis.diagnosis_details.objective" id="Objective" name="Objective" />
       <span class="sa-val-err">{{ errors[0] }}</span>
      </ValidationProvider>
      <div v-if="typeof diagnosis.diagnosis_details.assessment == 'string'" class="sa-card">
        <label class="sa-diagno-label">Assessment  <span class="sa-red-text">*</span>
        </label>
        <textarea class="sa-textarea" placeholder="Add here" rows="1" v-model="diagnosis.diagnosis_details.assessment" id="assessment" name="Assessment" />
      </div>
  <!-- only bupa refill -->
  <div v-else-if="diagnosis && diagnosis.refill && diagnosis.sales_channel == 'bupa_refill'" class="sa-card">
         <label class="sa-diagno-label">
            Assessment <span class="sa-red-text">*</span>
          </label>
          <div class="sa-row" id="a">
            <ValidationProvider class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg4"  tag="div" rules="required" name="primary diagnosis" v-slot="{ errors }">
            <p>Primary diagonosis <span class="sa-red-text">*</span></p>
            <div @click="problems(1)" class="sa-d-f-sbetween sa-diagonosis">
              <!-- <span  v-if="primary.length > 0" class="sa-diagnosis-cont">{{primary[0].icd10_code}} ({{primary[0].en}})</span>  -->
              <span v-if="diagnosis && diagnosis.diagnosis_details && diagnosis.diagnosis_details.assessment &&
               diagnosis.diagnosis_details.assessment.primary && diagnosis.diagnosis_details.assessment.primary.length > 0" class="sa-diagnosis-cont">
                {{diagnosis.diagnosis_details.assessment.primary[0].icd10_code}} ({{diagnosis.diagnosis_details.assessment.primary[0].desc}})
              </span>
              <input type="hidden" v-if="diagnosis && diagnosis.diagnosis_details && diagnosis.diagnosis_details.assessment &&
               diagnosis.diagnosis_details.assessment.primary && diagnosis.diagnosis_details.assessment.primary.length > 0" class="sa-textarea" placeholder="Add here" rows="1" v-model="diagnosis.diagnosis_details.assessment.primary[0].icd10_code" name="primary diagnosis" id="primaryDiagnosis" />
              <span v-else class="sa-diagnosis-cont">Select Primary diagonosis</span>
               <!-- <span v-if="primary.length > 1" class="sa-diagnosis-no">+{{primary.length - 1}}</span> -->
              <span v-if="diagnosis && diagnosis.diagnosis_details && diagnosis.diagnosis_details.assessment &&
               diagnosis.diagnosis_details.assessment.primary && diagnosis.diagnosis_details.assessment.primary.length > 1" class="sa-diagnosis-no">+{{diagnosis.diagnosis_details.assessment.primary.length - 1}}</span>
              <i class="icon-right-arrow sa-arrowcolor"></i>
            </div>
            <span class="sa-val-err">{{ errors[0] }}</span>
            </ValidationProvider>
            <!-- <primary-diagnosis v-show="showPopup" @close="closePop" /> -->
          <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg4">
            <p>Secondary diagonosis</p>
             <div class="sa-d-f-sbetween sa-diagonosis" @click="problems(2)">
              <span v-if="diagnosis && diagnosis.diagnosis_details && diagnosis.diagnosis_details.assessment && 
               diagnosis.diagnosis_details.assessment.secondary && diagnosis.diagnosis_details.assessment.secondary.length > 0" class="sa-diagnosis-cont">
                {{diagnosis.diagnosis_details.assessment.secondary[0].icd10_code}} ({{diagnosis.diagnosis_details.assessment.secondary[0].desc}})
              </span> 
              <span v-else class="sa-diagnosis-cont">Select secondary diagonosis</span>
               <span v-if="diagnosis && diagnosis.diagnosis_details && diagnosis.diagnosis_details.assessment && 
               diagnosis.diagnosis_details.assessment.secondary && diagnosis.diagnosis_details.assessment.secondary.length > 1" class="sa-diagnosis-no">+{{diagnosis.diagnosis_details.assessment.secondary.length - 1}}</span>
              <i class="icon-right-arrow sa-arrowcolor"></i>
             </div>
          </div>
          <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg4">
            <p>Additional diagonosis</p>
             <div class="sa-d-f-sbetween sa-diagonosis" @click="problems(3)">
             <span v-if="diagnosis && diagnosis.diagnosis_details && diagnosis.diagnosis_details.assessment &&
               diagnosis.diagnosis_details.assessment.additional && diagnosis.diagnosis_details.assessment.additional.length > 0" class="sa-diagnosis-cont">
                {{diagnosis.diagnosis_details.assessment.additional[0].icd10_code}} ({{diagnosis.diagnosis_details.assessment.additional[0].desc}})
              </span> 
              <span v-else class="sa-diagnosis-cont">Select additional diagonosis</span>
              <span v-if="diagnosis && diagnosis.diagnosis_details && diagnosis.diagnosis_details.assessment &&
               diagnosis.diagnosis_details.assessment.additional && diagnosis.diagnosis_details.assessment.additional.length > 1" class="sa-diagnosis-no">+{{diagnosis.diagnosis_details.assessment.additional.length - 1}}</span>
              <i class="icon-right-arrow sa-arrowcolor"></i>
             </div>
          </div>
     </div>
      </div>


      <div v-else  class="sa-card">
          <label class="sa-diagno-label">
            Assessment <span class="sa-red-text">*</span>
          </label>
          <div class="sa-row" id="a">
            <ValidationProvider class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg4"  tag="div" rules="required" name="primary diagnosis" v-slot="{ errors }">
            <p>Primary diagonosis <span class="sa-red-text">*</span></p>
            <div @click="$parent.primaryFlag = true" class="sa-d-f-sbetween sa-diagonosis">
              <!-- <span  v-if="primary.length > 0" class="sa-diagnosis-cont">{{primary[0].icd10_code}} ({{primary[0].en}})</span>  -->
              <span v-if="diagnosis && diagnosis.diagnosis_details && diagnosis.diagnosis_details.assessment &&
               diagnosis.diagnosis_details.assessment.primary && diagnosis.diagnosis_details.assessment.primary.length > 0" class="sa-diagnosis-cont">
                {{diagnosis.diagnosis_details.assessment.primary[0].icd10_code}} ({{diagnosis.diagnosis_details.assessment.primary[0].desc}})
              </span>
              <input type="hidden" v-if="diagnosis && diagnosis.diagnosis_details && diagnosis.diagnosis_details.assessment &&
               diagnosis.diagnosis_details.assessment.primary && diagnosis.diagnosis_details.assessment.primary.length > 0" class="sa-textarea" placeholder="Add here" rows="1" v-model="diagnosis.diagnosis_details.assessment.primary[0].icd10_code" name="primary diagnosis" id="primaryDiagnosis" />
              <span v-else class="sa-diagnosis-cont">Select Primary diagonosis</span>
               <!-- <span v-if="primary.length > 1" class="sa-diagnosis-no">+{{primary.length - 1}}</span> -->
              <span v-if="diagnosis && diagnosis.diagnosis_details && diagnosis.diagnosis_details.assessment &&
               diagnosis.diagnosis_details.assessment.primary && diagnosis.diagnosis_details.assessment.primary.length > 1" class="sa-diagnosis-no">+{{diagnosis.diagnosis_details.assessment.primary.length - 1}}</span>
              <i class="icon-right-arrow sa-arrowcolor"></i>
            </div>
            <span class="sa-val-err">{{ errors[0] }}</span>
            </ValidationProvider>
            <!-- <primary-diagnosis v-show="showPopup" @close="closePop" /> -->
          <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg4">
            <p>Secondary diagonosis</p>
             <div class="sa-d-f-sbetween sa-diagonosis" @click="$parent.secondaryFlag = true">
              <span v-if="diagnosis && diagnosis.diagnosis_details && diagnosis.diagnosis_details.assessment && 
               diagnosis.diagnosis_details.assessment.secondary && diagnosis.diagnosis_details.assessment.secondary.length > 0" class="sa-diagnosis-cont">
                {{diagnosis.diagnosis_details.assessment.secondary[0].icd10_code}} ({{diagnosis.diagnosis_details.assessment.secondary[0].desc}})
              </span> 
              <span v-else class="sa-diagnosis-cont">Select secondary diagonosis</span>
               <span v-if="diagnosis && diagnosis.diagnosis_details && diagnosis.diagnosis_details.assessment && 
               diagnosis.diagnosis_details.assessment.secondary && diagnosis.diagnosis_details.assessment.secondary.length > 1" class="sa-diagnosis-no">+{{diagnosis.diagnosis_details.assessment.secondary.length - 1}}</span>
              <i class="icon-right-arrow sa-arrowcolor"></i>
             </div>
          </div>
          <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg4">
            <p>Additional diagonosis</p>
             <div class="sa-d-f-sbetween sa-diagonosis" @click="$parent.additionalFlag = true">
             <span v-if="diagnosis && diagnosis.diagnosis_details && diagnosis.diagnosis_details.assessment &&
               diagnosis.diagnosis_details.assessment.additional && diagnosis.diagnosis_details.assessment.additional.length > 0" class="sa-diagnosis-cont">
                {{diagnosis.diagnosis_details.assessment.additional[0].icd10_code}} ({{diagnosis.diagnosis_details.assessment.additional[0].desc}})
              </span> 
              <span v-else class="sa-diagnosis-cont">Select additional diagonosis</span>
              <span v-if="diagnosis && diagnosis.diagnosis_details && diagnosis.diagnosis_details.assessment &&
               diagnosis.diagnosis_details.assessment.additional && diagnosis.diagnosis_details.assessment.additional.length > 1" class="sa-diagnosis-no">+{{diagnosis.diagnosis_details.assessment.additional.length - 1}}</span>
              <i class="icon-right-arrow sa-arrowcolor"></i>
             </div>
          </div>
     </div>
        </div>
                <ValidationProvider class="sa-card"  tag="div" rules="required" name="plan" v-slot="{ errors }">
        <label class="sa-diagno-label">Plan <span class="sa-red-text">*</span>
         </label>
        <textarea class="sa-textarea" placeholder="Add here" rows="1" v-model="diagnosis.diagnosis_details.plan" name="plan" id="plan" />
                  <span class="sa-val-err">{{ errors[0] }}</span>
                </ValidationProvider>
                <!-- <div>
                  <h5 class="sa-card-tit sa-mt20">Next Appointment</h5>
                  <div class="sa-row">
                    <div class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg4">
                      <v-select :options="['After 1 month']" class="diagno-select" id="PrescriptionStatus" name="Prescription Status" ><span slot="no-options">No data</span></v-select>
                    </div>
                  </div>
                </div> -->
      <div v-if="patDetails && patDetails.stid == 'ST1' && followupcheck && diagnosis && !diagnosis.followUp_check" class="sa-follow"> 
        <h5 class="sa-card-tit sa-mt20">Select follow up date and slot (Optional)</h5>
        <div class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg4">
            <div class="sa-card sa-card-noshadow sa-card-border sa-follow-icon">
                <div @click="followUp" v-if="!diagnosis.followUp">
                   Please Select Slot <i class="icon-picker"></i>
                </div>
                <template v-else >
                  <span id="i">
                  {{diagnosis.followUp_slot.date}} {{diagnosis.followUp_slot.strt_tym}} To {{diagnosis.followUp_slot.end_tym}}
                  <button @click="followUpCancel" class="sa-btn-transparent sa-red-text">Remove</button></span>
                </template>
            </div>
        </div>
    </div>
      <h5 class="sa-card-tit sa-mt30">Treatment details</h5>
      <div class="sa-treat-radio sa-d-flex">
          <input type="checkbox" :checked="diagnosis.prescription"  id="prescrition" name="prescrition" value="a" />
          <label for="prescrition" @click="prescription"><i class="icon-capsule"></i>Add Prescription</label>
          <input type="checkbox" :checked="diagnosis.treatment_referral"  id="referal" name="referal" value="t" />
          <label for="referal" class="sa-treat-referral" @click="treatReferral"><i class="icon-refferal"></i>Investigation and referral</label>
          <input  type="checkbox" :checked="diagnosis.sickLeave" id="sickleave" name="sickleave" value="g" />
          <label for="sickleave"  class="sa-treat-sick" @click="sickLeave"><i class="icon-sickleave"></i>Generate sick leave</label>
      </div>
      <div class="sa-ftr-btn">
        <button class="sa-btn sa-btn-large sa-btn-block-xs sa-btn-primary" @click="handleSubmit(saveDiagnosisDet)">Continue</button>
      </div>
        </ValidationObserver>
    </template>
  </div>
  </div>
</template>
<script>
import moment from "moment";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import _ from 'lodash';
import ReviewDiagnosisVue from './ReviewDiagnosis.vue';
import { pro_url, oh_url } from "../../../../config/endpoints";
import FollowUpVue from '../../appointments/diagnosis/FollowUpDate.vue';
// import TreatmentReferralVue from '../../../view/appointments/diagnosis/treatment-referral/TreatmentReferral.vue';
// import PrimaryDiagnosis from './PrimaryDiagnosis.vue';
extend('required', {
  ...required,
  message: 'Please provide {_field_}'
})
export default {
   mounted() {
        this.diagnosisDetails();
  },
  components: {
     "review-diagnosis": ReviewDiagnosisVue,
     "follow-up": FollowUpVue,
    //  "primary-diagnosis": PrimaryDiagnosis
  },
  props: ["primary", "secondary", "additional",'apnt'],
  params:["apnt"],
  data() {
    return {

      bupaPrimary:false,
      bupaSecondary:false,
      bupaAdditional:false,
      pat_inst: "",
      pInfo:"",
      apnt_date: null,
      date: null,
      saveDiagFlag: false,
      saveDiagDetFlag: false,
      followUpFlag:false,
      followupcheck: false,
      followUpViewFlag:false,
      additionalFlag: false,
      assessmentFlag : false,
      assessmentDetFlag : false,
      followup: null,
      loader: false,
      patDetails: null,
      plan : null,
      diagnosis: {
        general_details: {
          marital_status: null,
          pregnency_status: null,
          gender: null
        },
        diagnosis_details: {
          subjective	:	null,
          objective	:	null,
          plan	:	null, 
          assessment: null
          }
      }
    };
  },
    watch: {
      'diagnosis.diagnosis_details.plan' : {
        immediate: false,
        deep: true,
        handler (val) {
          if(val != ''){
              let plan = val
              this.$localStorage.set("plan", JSON.stringify(plan));
          }
        }
      },
    },
  methods: {   
  // closePop (){
  //     this.showPopup= false,
  //     this.showErrorPopup= false,
  //     this.closePop('close')
  //   },
  height(id){
        setTimeout(function () {
        let element = document.getElementById(id);
        element.scrollIntoView();
        }, 500)
      },
    problems(val){
       if (val == 1) {
          val = "Primary";
      } else if (val == 2) {
          val = "Secondary";
      } else {
          val = "Additional";
      }
      this.$router.push({ path: "/appointments/doctor-details/add-diagnosis/add-problems/" + this.$route.params.appid  + "?diagnosis="+val + "&ref_id=" + this.diagnosis.ref_id   });
    },
    prescription() {
      this.$router.push('/appointments/doctor-details/add-diagnosis/add-prescription/'+this.$route.params.appid)
    },
    treatReferral() {
      this.$router.push('/appointments/doctor-details/add-diagnosis/treatment-referral/'+this.$route.params.appid)
    },
    sickLeave() {
      this.$router.push('/appointments/doctor-details/add-diagnosis/sick-leave/'+this.$route.params.appid)
    },
    ReviewDiagnos() {
      this.$router.push('/appointments/doctor-details/review-diagnosis/'+this.$route.params.appid)
    },
    saveDiagnosisDet() {
        let _self = this;
      _self.loader = true;
      let preg_status = this.diagnosis.general_details ? (this.diagnosis.general_details.pregnency_status == 'Yes' ? true : false) : false
      if(typeof this.diagnosis.diagnosis_details.assessment == 'object'){
        this.diagnosis.diagnosis_details.assessment.primary = _.map(_self.diagnosis.diagnosis_details.assessment.primary, e => {
          e = e.icd10_code
          return e
        })
        this.diagnosis.diagnosis_details.assessment.secondary = _.map(_self.diagnosis.diagnosis_details.assessment.secondary, e => {
          e = e.icd10_code
          return e
        })
        this.diagnosis.diagnosis_details.assessment.additional = _.map(_self.diagnosis.diagnosis_details.assessment.additional, e => {
          e = e.icd10_code
          return e
        })
      }
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/apt/update`,
          body: {
            apnt_id: _self.$route.params.appid,
            summary: this.diagnosis.diagnosis_details.assessment,
            preg_status: preg_status,
            treatment_plan: this.diagnosis.diagnosis_details.plan,
            subjective: this.diagnosis.diagnosis_details.subjective,
            objective: this.diagnosis.diagnosis_details.objective,
            marital_status: this.diagnosis.general_details.marital_status
          },
        })
        .then((response) => {
          _self.loader = false;
          if (response && response.status === 1000) {
            this.ReviewDiagnos()
            //_self.diagnosis = response.data;
            _self.saveDiagDetFlag = true
          }
          
        })
      // if(!this.saveDiagFlag) {
      //   this.saveDiagFlag = true
      //   this.saveDiagDetFlag = true
      // } else {
      //   this.saveDiagFlag = false
      //   this.saveDiagDetFlag = false
      // }
    },
    followUp(){
        if(!this.followUpFlag){
          this.followUpFlag =true
          this.followUpViewFlag =true
        }
        else{
          this.followUpFlag =false
          this.followUpViewFlag =false
        }
      },
      diagnosisDetails(){
      let _self = this;
      _self.loader = true;
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/diagnosis/diagnosisDetails`,
          body: {
            apnt_id: _self.$route.params.appid,
          },
        })
        .then((response) => {
          _self.loader = false;
          if (response && response.status === 1000) {
            _self.patDetails = JSON.parse(_self.$localStorage.get("patDetails"))
            _self.plan = JSON.parse(_self.$localStorage.get('plan')) ? JSON.parse(_self.$localStorage.get('plan')) : ''
            _self.apnt_date = moment(_self.patDetails.apnt_date) 
              let dt = moment(this.patDetails.apnt_date).add(14, 'days').format("YYYY-MM-DD");
              let cur_dt = moment().format("YYYY-MM-DD")
              if(moment(cur_dt).isSameOrBefore(moment(dt))){
                  this.followupcheck = true
                }else {
                    this.followupcheck = false
              }
            _self.diagnosis = response.data;
            if(_self.diagnosis.followUp_slot && _self.diagnosis.followUp_slot.date){
                _self.$localStorage.set('followUp', JSON.stringify(_self.diagnosis.followUp_slot))
            }
            _self.diagnosis.diagnosis_details.plan = _self.diagnosis.diagnosis_details.plan ? _self.diagnosis.diagnosis_details.plan : _self.plan
            _self.diagnosis.general_details.pregnency_status = _self.diagnosis.general_details ? (_self.diagnosis.general_details.pregnency_status == true ? 'Yes' : "No") : "No"
           let data = {}
           if (_self.diagnosis.diagnosis_details.assessment) {
              _self.$parent.primaryDiag = _.map(_self.diagnosis.diagnosis_details.assessment.primary,e => {
                data[e.icd10_code] = e.icd10_code + ' ' + e.desc
                  e = e.icd10_code
                  return e
              })
              _self.$parent.secondaryDiag = _.map(_self.diagnosis.diagnosis_details.assessment.secondary,e => {
                data[e.icd10_code] = e.icd10_code + ' ' + e.desc
                  e = e.icd10_code
                  return e
              })
              _self.$parent.additionalDiag = _.map(_self.diagnosis.diagnosis_details.assessment.additional,e => {
                data[e.icd10_code] = e.icd10_code + ' ' + e.desc
                  e = e.icd10_code
                  return e
              })
            }
            _self.$localStorage.set('assesment', JSON.stringify(data))
            
          }
        })
    },
     followUpCancel(){
      let _self = this;
      _self.loader = true;
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/followUp/removeSlot`,
          body: {
            apnt_id: _self.$route.params.appid,
          },
        })
        .then((response) => {
          _self.loader = false;
          if (response && response.status === 1000) {
            _self.diagnosisDetails();
            _self.$localStorage.remove('followUp')
             _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: response.message,
              class: "sa-a-success"
            });
          }else {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: response.message,
              class: "sa-a-danger"
            });
          }
        })
    },
     assessmentDet(){
        let _self = this
      _self.loading = true
      _self.$store.dispatch('httpPost', {
        uri:`${oh_url}/general/ICD10codesList`,
        body: {
          limit: 10,
          page: 1,
          en: ""
        }
      }).then(response => {
        _self.loading = false
        if (response && response.status === 1000) {
          _self.assessment = response.data
          if(!_self.assessmentFlag) {
            _self.assessmentFlag = true
            _self.assessmentDetFlag = true
          }else {
            _self.assessmentFlag = false
            _self.assessmentDetFlag = false
          }
        }
      })
    },
  }
};
</script>
